import { FC } from "react"
import { t } from "i18next";

// Components
import { Box } from "@mui/material";
import Button from "@/components/button";
import FilterMenu from "@/components/datatable/filter/other_menu";
import FilterSelect, { ISelectItem } from "@/components/datatable/filter/filter_select";


export type FilterState = Record<string, string[]>;

export interface FilterItem {
    type: 'primary' | 'secondary';
    label: string;
    // Name of the field to filter (corresponds to headers)
    field: string;
    // List of items to filter by
    items: ISelectItem[];
    // Key of the item to filter by
    itemKey: string;
}

export interface FilterBarProps {
    filterItems: FilterItem[];
    filters: FilterState;
    setFilter: (field: string, values: string[]) => void;
    resetFilters: () => void;
}

const FilterBar: FC<FilterBarProps> = ({
    filterItems,
    filters,
    setFilter,
    resetFilters
}) => {

    const primaryFilters = filterItems.filter((f) => f.type === 'primary');
    const secondaryFilters = filterItems.filter((f) => f.type === 'secondary');

    const handleSetFilter = (field: string, value: string[]) => {
        setFilter(field, value);
    };

    const handleResetFilters = () => {
        resetFilters();
    };

    const handleFilterItemSelect = (field: string, value: string) => {
        const selected = filters[field] || [];
        const updated = selected.includes(value)
        ? selected.filter((v) => v !== value)
        : [...selected, value];
        setFilter(field, updated);
    };

    return (
        <Box display="flex" alignItems="center">
            <Button
                kind="ghost"
                size="small"
                label="Reset Filters"
                minWidth={false}
                onClick={handleResetFilters}
                sx={{mr: '8px'}}
                />
            <span className="label-text-01" style={{color: 'var(--text-secondary)', marginRight: '8px'}}>{t('components.dataTable.filterBy')}</span>

            {primaryFilters.map((filter) => 
                <FilterSelect
                    key={filter.label}
                    label={filter.label}
                    selectedItems={filters[filter.field] ?? []}
                    items={filter.items}
                    itemKey={filter.itemKey}
                    onChange={(v) => handleSetFilter(filter.field, v)}
                    sx={{color: 'red'}}
                    />
            )}

            {/* Dropdown for additional filters */}
            {secondaryFilters.length > 0 &&
                <FilterMenu
                    closeOnClick={false}
                    options={secondaryFilters.map((filter) => ({
                        name: filter.label,
                        action: () => {},
                        options: filter.items.map((item) => ({
                            name: item.label,
                            action: () => handleFilterItemSelect(filter.field, item.value),
                            selected: filters[filter.field]?.includes(item.value)
                        }))
                    }))}
                    />}

        </Box>
    )
}

export default FilterBar;